import React, { useState } from "react";
import { Button } from "../../common/Button/Button";
import {
  MessagesBackground,
  MessageWrapper,
  MessageBox,
  MessageAuthor,
  MessageText,
  MessageTimestamp,
  EmptyStateMessage,
  AddMessageButton,
  ButtonsContainer,
  InputContainer,
  TextArea,
} from "./TestConversationMessages.styles";

export const TestConversationMessages = ({
  conversationData,
  setConversationData,
  t,
  disableEditing = false,
}) => {
  const [newMessage, setNewMessage] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [messageType, setMessageType] = useState(null); // "client" or "agent"

  const handleAddMessage = () => {
    if (!newMessage.trim() || disableEditing) return;

    const isClient = messageType === "client";

    const newMessageObj = {
      id: Date.now().toString(),
      content: newMessage,
      sender: isClient ? "Client" : "Support Agent",
      isClient: isClient,
      date: new Date().toLocaleString(),
    };

    setConversationData([...conversationData, newMessageObj]);
    setNewMessage("");
    setShowInput(false);
  };

  const startAddingMessage = (type) => {
    if (disableEditing) return;
    setMessageType(type);
    setShowInput(true);
  };

  const cancelAddingMessage = () => {
    setShowInput(false);
    setNewMessage("");
  };

  return (
    <>
      <MessagesBackground>
        {conversationData.length === 0 ? (
          <EmptyStateMessage>{t("logs.noConversationData")}</EmptyStateMessage>
        ) : (
          conversationData.map((message) => {
            const { sender, isClient } = message;
            return (
              <MessageWrapper key={message.id} $isClient={isClient}>
                <MessageBox $isClient={isClient}>
                  <MessageAuthor>{sender}</MessageAuthor>
                  <MessageText>{message.content}</MessageText>
                  <MessageTimestamp>{`${message.date}`}</MessageTimestamp>
                </MessageBox>
              </MessageWrapper>
            );
          })
        )}
      </MessagesBackground>

      {!showInput ? (
        <ButtonsContainer>
          <AddMessageButton
            onClick={() => startAddingMessage("client")}
            $isClient={true}
            disabled={disableEditing}
          >
            + {t("test.addClientMessage")}
          </AddMessageButton>
          <AddMessageButton
            onClick={() => startAddingMessage("agent")}
            $isClient={false}
            disabled={disableEditing}
          >
            + {t("test.addAgentMessage")}
          </AddMessageButton>
        </ButtonsContainer>
      ) : (
        <>
          <InputContainer>
            <TextArea
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder={
                messageType === "client"
                  ? t("test.clientMessagePlaceholder")
                  : t("test.agentMessagePlaceholder")
              }
              disabled={disableEditing}
            />
          </InputContainer>
          <ButtonsContainer>
            <Button
              text={t("common.add")}
              onClick={handleAddMessage}
              variant="violet"
              disabled={disableEditing || !newMessage.trim()}
            />
            <Button
              text={t("common.cancel")}
              onClick={cancelAddingMessage}
              variant="white"
              disabled={disableEditing}
            />
          </ButtonsContainer>
        </>
      )}
    </>
  );
};
